<template>
    <UTooltip v-if="subscription" :text="expiryDate">
        <UBadge v-if="expiresInDays <= 30" color="red" :label="expiryLabel" variant="subtle" />
        <UBadge v-else-if="expiresInDays <= 90" color="orange" :label="expiryLabel" variant="subtle" />
        <UBadge v-else color="blue" :label="expiryLabel" variant="subtle" />
    </UTooltip>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { type Subscription } from '~/types/subscription';

const props = defineProps<{
    subscription?: Subscription
}>()

const expiryDate = computed(() => {
    return props.subscription ? dayjs(props.subscription.expires_at).format('MMM D, YYYY') : undefined
})

const expiresInDays = computed(() => {
    return props.subscription ? dayjs(props.subscription.expires_at).diff(dayjs(), 'days') : 0
})

const expiryLabel = computed(() => {
    if (expiresInDays.value < -1) {
        return `${Math.abs(expiresInDays.value)} days ago`
    }
    else if (expiresInDays.value === -1) {
        return 'Yesterday'
    }
    else if (expiresInDays.value === 0) {
        return 'Expires today'
    }
    else if (expiresInDays.value === 1) {
        return 'Expires tomorrow'
    }
    else {
        return `Expires in ${expiresInDays.value} days`
    }
})
</script>